import { render, staticRenderFns } from "./actionsColumnWithManageAccess.vue?vue&type=template&id=6bb253a9&scoped=true"
import script from "./actionsColumnWithManageAccess.vue?vue&type=script&lang=js"
export * from "./actionsColumnWithManageAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb253a9",
  null
  
)

export default component.exports